import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Label, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { faCircle as faCircleOutline } from '@fortawesome/free-regular-svg-icons'
import * as utilities from '../../utilities';

class AdminUsers extends Component {

  standardRow = (user) => {
    return (
      <Row className="adminRow pointer" onClick={() => this.props.onEdit(user.Auth0)}>
        <Col className="text-left col-md-4">
          <FontAwesomeIcon icon={(user['Active']) ? faCircle : faCircleOutline} className={"mr-3 " + ((user['Active']) ? 'iconActive' : 'iconInactive')} />
          {user['Full Name']}
        </Col>
        <Col className="text-left col-md-5">{user['Email Address']}</Col>
        <Col className="text-left col-md-3">{user.Title || ''}</Col>
        {/* <Col className="text-right col-md-4">
          <Button color="primary" onClick={() => this.props.onEdit(user.Auth0)}>
            <FontAwesomeIcon icon={faEdit} />
          </Button>
        </Col> */}
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col>
        <Form inline>
          {/* <FormGroup className="pr-2">
            Add New Role
          </FormGroup> */}
          <FormGroup className="px-2">
            <Input
              placeholder="First Name"
              type="text"
              name="firstName"
              value={utilities.isFieldNull(this.props.newUser.firstName)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Last Name"
              type="text"
              name="lastName"
              value={utilities.isFieldNull(this.props.newUser.lastName)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Title"
              type="text"
              name="title"
              value={utilities.isFieldNull(this.props.newUser.title)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              placeholder="Email Address"
              type="text"
              name="emailAddress"
              value={utilities.isFieldNull(this.props.newUser.emailAddress)}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="px-2">
            <Input
              type="checkbox"
              name="active"
              id="user-active"
              checked={utilities.isFieldNull(this.props.newUser.active, true)}
              onChange={e => this.props.onChange(e)} />
            <Label for="user-active">
              Active
            </Label>
          </FormGroup>
          <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"user-alwaysFirstLast-add"}
                name="alwaysFirstLast"
                checked={utilities.isFieldNull(this.props.newUser.alwaysFirstLast, true)}
                onChange={e => this.props.onChange(e)} />
              <Label for={"user-alwaysFirstLast-add"}>
                Display as First Name Last Name
              </Label>
            </FormGroup>
        </Form>
      </Col>
      <Col md={2} className="text-right">
        <Button disabled={this.props.newUser.emailAddress === ''} color="primary" onClick={this.props.handleAdd}>Add User</Button>
      </Col>
    </Row>
    )
  }

  editRow = (user) => {
    return (<>
      <Row key={"edit" + user.Auth0} className="adminRow">
        <Col className="text-left col-md-10">
          <Form inline>
            <FormGroup className="pr-2">
              <Input
                placeholder="First Name"
                type="text"
                id={"edit-firstName" + user.auth0}
                name="firstName"
                value={this.props.editUser.firstName}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Last Name"
                type="text"
                id={"edit-lastName" + user.auth0}
                name="lastName"
                value={this.props.editUser.lastName}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Title"
                type="text"
                id={"edit-title" + user.auth0}
                name="title"
                value={this.props.editUser.title}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                placeholder="Email Address"
                type="text"
                id={"edit-emailAddress" + user.auth0}
                name="emailAddress"
                value={this.props.editUser.emailAddress}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"user-active" + user.Auth0}
                name="active"
                checked={this.props.editUser.active}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"user-active" + user.Auth0}>
                Active
              </Label>
            </FormGroup>
            <FormGroup className="px-2">
              <Input
                type="checkbox"
                id={"user-alwaysFirstLast"}
                name="alwaysFirstLast"
                checked={this.props.editUser.alwaysFirstLast}
                onChange={e => this.props.onChange(e, 'edit')} />
              <Label for={"user-alwaysFirstLast"}>
                Display as First Name Last Name
              </Label>
            </FormGroup>
          </Form>
        </Col>
        <Col className="text-right col-md-2">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit User">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          {/* <Button className="mx-3" color="danger" onClick={() => this.props.onDelete(user.Auth0)}>
            <FontAwesomeIcon icon={faTrashAlt} />
          </Button> */}
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
        <Col className="text-left col-md-12 p-3">
          <div className="font-weight-bold mb-2">Assigned Roles</div>
          {this.props.roles.map(role => (
            <Label className="d-block" key={role.ID} for={"userRole_" + role.ID}>
              <Input
                type="checkbox"
                name="roles"
                id={"userRole_"+role.ID}
                checked={this.props.editUser.roles.findIndex(i => i === parseInt(role.ID)) > -1}
                onChange={e => this.props.onChange(e, 'edit')}
              />
              {role.Role}
            </Label>
          ))}
        </Col>
        <Col className="text-left col-md-12 p-3 border-top">
          <div className="font-weight-bold mb-2">Document Signature</div>
          <div className="d-flex align-items-start flex-wrap">
            <div className="mr-4 mb-3">
              {this.props.editUser.documentSignaturePreview ? (
                <img
                  src={this.props.editUser.documentSignaturePreview}
                  alt="Document signature preview"
                  style={{ maxWidth: '320px', maxHeight: '90px', objectFit: 'contain' }}
                />
              ) : (
                <span className="text-muted">No document signature uploaded.</span>
              )}
            </div>
            <div className="flex-grow-1">
              <Label for={`document-signature-${user.Auth0}`} className="d-block">Upload Document Signature</Label>
              <Input
                id={`document-signature-${user.Auth0}`}
                type="file"
                accept="image/png"
                onChange={event => this.props.onDocumentSignatureFile(event.target.files?.[0])}
              />
              <small className="text-muted d-block mt-1">Transparent PNG, maximum 2 MB.</small>
              {(this.props.editUser.hasDocumentSignature || this.props.editUser.documentSignatureDataUrl) && !this.props.editUser.removeDocumentSignature ? (
                <Button
                  className="mt-2"
                  color="danger"
                  onClick={this.props.onRemoveDocumentSignature}
                  title="Remove document signature"
                >
                  <FontAwesomeIcon icon={faTrashAlt} className="mr-2" />
                  Remove Document Signature
                </Button>
              ) : null}
            </div>
          </div>
        </Col>
      </Row>
    </>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.users.map(user => (
          <Fragment key={user.Auth0}>{this.props.editUser.auth0 === user.Auth0 ? this.editRow(user) : this.standardRow(user)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );

  }
}

export default AdminUsers;
